import { useState } from "react";
import { CheckMarkIcon } from "../icons/CheckMarkIcon";
import "./styles.css";

export const CheckBox = ({
  initialState = false,
  value,
  className = "",
  onClick,
}) => {
  const [internalChecked, setInternalChecked] = useState(initialState);

  // if value is provided → controlled, else fallback to internal state
  const checked = value !== undefined ? value : internalChecked;

  const handleClick = () => {
    if (value === undefined) {
      setInternalChecked((prev) => !prev);
    }

    if (onClick) onClick(!checked);
  };

  return (
    <div className={`checkbox ${className}`} onClick={handleClick}>
      {checked && <CheckMarkIcon className="checkmark" thickness={"2.5"} />}
    </div>
  );
};
